/*
 * File: permission.ts
 * File Created: 2023-11-27 03:21:15
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-13 02:53:00
 * Modified By: Val Liu
 * -----
 */

import { IRouterAuth, PermissionHelper } from "@root/core/utilities/permission-helper";
import { ObjectHelper } from "@root/core";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class IVPermission extends Vue implements IRouterAuth {
    @Prop({ type: [Function, Object], required: false, default: null })
    allow!: IRouterAuth["allow"];

    @Prop({ type: [Function, Object], required: false, default: null })
    deny!: IRouterAuth["deny"];

    private isAllowed(): boolean {
        return PermissionHelper.authRouter.call(this, this);
    }

    private render(h) {
        if (this.isAllowed()) {
            return this.$slots.default;
        }
        return this.$slots["@else"];
    }
}

const ACTIVE = Symbol("PERMISSION_ACTIVE");
const COMMENT = Symbol("PERMISSION_COMMENT");
const UPDATE = Symbol("PERMISSION_UPDATE");
const PARENT = Symbol("PERMISSION_PARENT");

Vue.directive("permission", {
    bind(el, binding, vnode) {
        /// Create a comment node as a placeholder
        const commentNode = document.createComment("Permission placeholder");

        /// A reference to keep track of whether the element is currently displayed
        el[ACTIVE] = true;
        el[COMMENT] = commentNode;

        function updateDisplay(value: IRouterAuth) {
            const vue = vnode.context;
            const parent = el[PARENT];

            const isAllowed = PermissionHelper.authRouter.call(vue, value);
            console.log("allowed?", isAllowed);
            if (isAllowed && !el[ACTIVE]) {
                parent.replaceChild(el, commentNode);
                el[ACTIVE] = true;
            } else if (!isAllowed && el[ACTIVE]) {
                parent.replaceChild(commentNode, el);
                el[ACTIVE] = false;
            }
        }

        el[UPDATE] = updateDisplay;
    },

    inserted(el, binding) {
        el[PARENT] = el.parentNode;
        el[UPDATE](binding.value);
    },

    componentUpdated(el, binding) {
        const { value, oldValue } = binding;
        if (ObjectHelper.equals(value, oldValue)) return;
        el[UPDATE](value);
    },

    unbind(el) {
        const comment = el[COMMENT];
        if (comment && comment.parentNode) {
            comment.parentNode.removeChild(comment);
        }
        /// clean up properties
        delete el[ACTIVE];
        delete el[COMMENT];
        delete el[UPDATE];
    },
});
